export default {
  state: {
    loading: true,
    platform: '', // 用户平台所在平台 WX：微信 IPH：苹果 ADR：安卓  PC：电脑
    isWechat: false, // 是否为微信平台
    isAndroid: false, // 是否为安卓平台
    authorizeBeforePath: '', // 身份验证前（login，agree，setting）的路径，用于登录后跳转
  },
  getters: {
    loading: state => state.loading,
    // 用户平台所在平台
    platform: state => state.platform,
    // 是否是微信登录的
    isWechat(state) {
      return state.isWechat
    },
    // 是否为安卓平台
    isAndroid: state => state.isAndroid,
    // 设置返回路由
    authorizeBeforePath(state) {
      return state.authorizeBeforePath
    },
  },
  mutations: {
    // 设置已经初始化
    setInited(state) {
      state.isInit = true;
    },
    // 设置平台信息
    setPlatform(state) {
      try {
        const userAgent = navigator.userAgent;
        const isWechat = /MicroMessenger/i.test(userAgent);
        if (isWechat) {
          state.platform = 'WX';
          state.isWechat = true;
        } else {
          const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1;
          const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          if (isIOS) {
            state.platform = 'IPH';
          } else if (isAndroid) {
            state.platform = 'ADR';
            state.isAndroid = true;
          } else {
            state.platform = 'PC';
          }
        }
      } catch (error) {
        console.log(error);
        state.platform = '';
        state.isWechat = false;
        state.isAndroid = false;
      }
    },
    // 展示加载页面
    showLoad(state) {
      state.loading = true;
    },
    // 隐藏加载页面
    hideLoad(state) {
      state.loading = false;
    },
    // 设置验证前页面路径
    setAuthorizeBeforePath(state, path) {
      state.authorizeBeforePath = path;
    },
  },
  actions: {
    // 初始化
    async init({ state, commit, dispatch }) {
      if (state.isInit) {
        return;
      }
      await dispatch('user/init');
      // 获取平台信息
      commit('setPlatform');
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/base.js